import React from "react";

function Skills() {
    return (
        <section className="skills">
            Skills
            <ul className="skills-points">
                <li>SOLIDWORKS</li>
                <li>CAD</li>
                <li>GD&T</li>
                <li>Tolerance Stack-Up</li>
                <li>DXF</li>
                <li>DFM/DFA</li>
                <li>PPAP</li>
                <li>Poka-Yoke</li>
                <li>Plex (ERP/MES)</li>
                <li>G-Code</li>
                <li>Wire Arc Additive Manufacturing (WAAM)</li>
                <li>Tecplot 360</li>
                <li>Python</li>
                <li>Fortran</li>
                <li>MATLAB</li>
                <li>MS Excel</li>
                <li>monday.com</li>
            </ul>
        </section>
    );
}

export default Skills;
